// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Visualization from './components/Visualization';
import ProjectPage from './components/ProjectPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Visualization />} />
        <Route path="/projects/:cohort/:projectId" element={<ProjectPage />} />
      </Routes>
    </Router>
  );
}

export default App;
